import PropTypes from 'prop-types';

import { DSIcon } from '@spotahome/ui-library/base';

import './DropdownTabs.scss';
import ToggleViewButton from '../ToggleViewButton';

const defaultFn = () => {};

const DropdownTabs = ({
  activeIndex = 0,
  items = [],
  name,
  isViewTable = false,
  onChange = defaultFn,
  handleOnClick = defaultFn
}) => {
  const handleChange = event => {
    const selectedIndex = items.findIndex(
      item => item.id === event.target.value
    );
    onChange(selectedIndex);
  };

  const activeTab = items[activeIndex];
  return (
    <div className="dropdown-tabs">
      <div className="dropdown-tabs__controls">
        <div className="dropdown-tabs__select-wrapper">
          <select
            id={name}
            name={name}
            className="dropdown-tabs__select"
            onChange={handleChange}
            value={items[activeIndex].id}
          >
            {items.map(item => (
              <option
                key={`option-${item.id}`}
                value={item.id}
                className="dropdown-tabs__option"
              >
                {item.label}
              </option>
            ))}
          </select>
          <DSIcon
            name="arrow_full_bottom"
            className="dropdown-tabs__chevron-icon"
          />
        </div>
        <ToggleViewButton onClick={handleOnClick} isViewTable={isViewTable} />
      </div>
      <div className="dropdown-tabs__content">{activeTab.render()}</div>
    </div>
  );
};

DropdownTabs.propTypes = {
  activeIndex: PropTypes.number,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      render: PropTypes.func
    })
  ),
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  isViewTable: PropTypes.bool,
  handleOnClick: PropTypes.func
};

export default DropdownTabs;
